import {
  makeStyles,
  Typography,
  Button,
  ButtonProps,
  CircularProgress,
} from "@material-ui/core";
import { ITheme } from "../constants/theme";
import BlockRoundedIcon from '@material-ui/icons/BlockRounded';

interface IProps extends ButtonProps {
  loading?: boolean;
}

export const OrderRejectButton = (props: IProps) => {
  const classes = useStyles();

  return (
    <Button
      className={classes.button}
      {...props}
      disabled={props.disabled || props.loading}
      startIcon={
        props.startIcon ? props.startIcon : props.loading ? (
          <CircularProgress style={{ height: '16px', width: '16px' }} color="inherit" />
        ) : (
          <BlockRoundedIcon
            color="error"
            fontSize="inherit"
          />
        )
      }>
      <Typography
        variant="button"
        component="p"
        className={classes.text}
      >
        {props.title}
      </Typography>
    </Button>
  );
};

const useStyles = makeStyles((theme: ITheme) => ({
  button: {
    color: theme.palette.error.main,
    padding: '6px 8px',
    textTransform: "none",
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.error[16]
    },
    '&:active': {
      backgroundColor: theme.palette.error[32]
    },
  },
  text: {
    textTransform: "none",
  },
  icon: {
    width: 18,
    height: 18,
    marginRight: 8
  },
}));